<div class="title-wrap d-flex align-items-start justify-content-between" id="competitor">
  <div class="sec-title">Top Competitors</div>
  <!-- <a class="btn btn-grey-bg">See All
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8319 5.58362C12.056 5.81604 12.056 6.18415 11.8319 6.41658L7.20333 11.2166C6.97332 11.4551 6.59348 11.462 6.35495 11.232C6.11641 11.002 6.10951 10.6222 6.33952 10.3836L9.98792 6.6001L0.599999 6.6001C0.268629 6.6001 -2.50526e-07 6.33147 -2.36042e-07 6.0001C-2.21557e-07 5.66873 0.268629 5.4001 0.599999 5.4001L9.98791 5.4001L6.33952 1.61658C6.10951 1.37804 6.11641 0.998208 6.35495 0.768191C6.59348 0.538175 6.97332 0.545081 7.20333 0.783617L11.8319 5.58362Z" fill="white"/>
    </svg>
  </a> -->
</div>
<div class="user-list-wrap row">
  <div *ngFor="let competitor of top_competitor" class="col-sm col-md-6">
    <app-minimal-company-card
      [top_competitor]="competitor"
    ></app-minimal-company-card>
  </div>
</div>
